import Icon from '../components/Icon.vue'

Icon.register({
  'user-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M633.8 458.1c7 5.4 8.3 15.5 2.9 22.3l-19.6 25.3c-5.5 7-15.5 8.2-22.5 2.8l-588.4-454.7c-7-5.4-8.2-15.4-2.8-22.4l19.6-25.2c5.5-7 15.5-8.2 22.5-2.8l147.6 114c5.4-65.6 59.8-117.4 126.9-117.4 70.7 0 128 57.3 128 128 0 55.8-35.9 102.7-85.7 120.3zM96 422.4c0-66.4 48.2-121.1 111.4-132.1l286.8 221.7h-350.2c-26.5 0-48-21.5-48-48v-41.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-slash.js
// module id = 2075
// module chunks = 0